module.exports = __webpack_public_path__ + "static/media/and_scr_share_in_chat.4074c998.png";